export default __webpack_public_path__ + "static/media/landing_page_img_1.05baf42e.png";